export default __webpack_public_path__ + "static/media/logo-call-activity.dc92e235.png";